import React from 'react';
import Link from 'gatsby-link';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MarvelLink from '@marvelapp/marvel-ui/link';

import UserTestingArtwork from 'marketing-website/components/modules/UserTestingArtwork';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import RevealWrapper from 'marketing-website/components/wrappers/RevealWrapper';

export default function UserTesting() {
  return (
    <Spacing type="padding" size="xl" position="topBottom">
      <PageWrap size="l">
        <RevealWrapper>
          <Grid columns={12}>
            <GridItem columnSpan={12} columnSpanM={7} alignContent="center">
              <UserTestingArtwork color="lightTeal" patternColor="teal" />
            </GridItem>
            <GridItem columnSpan={12} columnSpanM={5} alignContent="center">
              <HeadingBlock
                size="xs"
                title="Validate ideas with user testing"
                copy={
                  <span>
                    Keep user experience at the forefront of your product with{' '}
                    <Link to="/user-testing/">
                      <MarvelLink type="blue">user testing</MarvelLink>
                    </Link>
                    , where you can gain invaluable design feedback on your
                    prototype from your target audience, customers and
                    stakeholders.
                    <br />
                    <br />
                    Watch how they navigate through your prototype with screen,
                    audio and video recordings.
                  </span>
                }
              />
            </GridItem>
          </Grid>
        </RevealWrapper>
      </PageWrap>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/prototyping/UserTesting.js